import * as React from 'react';

import config from '@/server/config';
import request from '@/server/request';
import store from '@/redux/index';
import * as ExpertEditReducer from '@/redux/pages/expert-edit';

export default class Expert extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            expertData: {}
        }
    }

    public render() {
        const expertData = this.state.expertData;
        return (
            <section className="expert">
                <img src={require('../../../assets/images/expert-banner.png')} alt="" />
                <div className="expert-process">
                    <h1>专家入驻流程</h1>
                    <dl>
                        <dt>1、申请须知</dt>
                        <dd>
                            申请须知:(申请提示)<br />
                            1、具有化工、涂料、塑料合成工艺、产品应用、具有独到的见解<br />
                            2、对化工、涂料、塑料合成工艺、产品应用、具有独到的见解<br />
                            3、解读化工、涂料、塑料行业政策、法规、标准<br />
                            4、热衷于分享化工、涂料、塑料行业技术知识和丰富的行业经验
                        </dd>
                    </dl>
                    <dl>
                        <dt>2、申请审核</dt>
                        <dd>
                            1、管理员1个工作日内反馈审核结果<br />
                            2、用户进入个人中心可查看申请进度
                        </dd>
                    </dl>
                    <dl>
                        <dt>3、发布文章、在线课堂、参与活动</dt>
                        <dd>
                            1、发布专家个人文章<br />
                            2、申请在线课堂开课
                        </dd>
                    </dl>
                </div>
                {
                    expertData.auditStatus === 0 ? <p className="expert-status-text">您的申请已经提交，管理员会在1个工作日内审核。</p> : null
                }
                {
                    expertData.auditStatus === -1 ? <p className="expert-status-text">您的申请未通过，请您返回修改相关资料，重新提交申请。</p> : null
                }
                {
                    expertData.auditStatus == null || expertData.auditStatus === -1 ?
                    <div className="expert-apply">
                        <span onClick={() => this.navigateApply()}>申请加入专家库</span>
                    </div> : null
                }     
            </section>
        )
    }
    public componentDidMount() { 
        this.getData();
    }
    // 加载页面数据
    private async getData() { 
        const r = await request({
            url: `${config.API}member/expert/details`
        });
        if (r.code === -1 && r.message === 'error-logon') {
            return this.props.history.push('/login');
        }
        if (r.code === 1) {
            this.setState({
                expertData: r.obj.expert
            });
        }
    }

    // 申请成为专家
    private navigateApply() { 
        store.dispatch({
            type: ExpertEditReducer.types.INIT,
            initData: this.state.expertData
        });
        this.props.history.push(`/expert/edit?id=${this.state.expertData.id || ''}&edit=0`);
    }
}